import { render } from "./DetalharRecesso.vue?vue&type=template&id=2858efe3&scoped=true"
import script from "./DetalharRecesso.vue?vue&type=script&lang=js"
export * from "./DetalharRecesso.vue?vue&type=script&lang=js"

import "./DetalharRecesso.vue?vue&type=style&index=0&id=2858efe3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2858efe3"]])

export default __exports__